import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { ButtonWithText } from "../../utils/ButtonWithText";
import { BoardContainer } from "./BoardContainer";
import { BoardManager } from "./BoardManger";

export class HintsButtonContainer extends Phaser.GameObjects.Container {

    private hintsLabelBackground: Phaser.GameObjects.Graphics;
    private hintsCounterLabel: Phaser.GameObjects.Text;
    private hintButton: Button;
    private rewardedAdsButton: ButtonWithText;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.hintButton = new Button(this.scene, 425, 48, "texture_atlas_1", "btn_hints_off", "btn_hints_on");
        this.hintButton.onDown(this.onClickHint, this);
        this.add(this.hintButton);

        this.hintsLabelBackground = new Phaser.GameObjects.Graphics(this.scene);
        this.hintsLabelBackground.fillStyle(0xe41e37);
        this.hintsLabelBackground.x = this.hintButton.x + 32;
        this.hintsLabelBackground.y = this.hintButton.y - 24;
        this.hintsLabelBackground.fillCircle(0, 0, 16);
        this.add(this.hintsLabelBackground);

        this.hintsCounterLabel = new Phaser.GameObjects.Text(this.scene, this.hintsLabelBackground.x, this.hintsLabelBackground.y, "", {fontFamily: "OpenSans-CondLight", fontSize: 27, color: "#FFFFFF"});
        this.hintsCounterLabel.setOrigin(.5);
        this.add(this.hintsCounterLabel);

        const rewardedAdButtonImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_extra_hints");
        const rewardedAdButtonLabel = new Phaser.GameObjects.Text(this.scene, -16, 0, gameText.GET_3_HINTS[lan], {fontFamily: "OpenSans-CondLight", fontSize: 24, color: "#FFFFFF"});
        rewardedAdButtonLabel.setOrigin(.5);
        rewardedAdButtonLabel.scaleX = .75;

        this.rewardedAdsButton = new ButtonWithText(this.scene, rewardedAdButtonImg, rewardedAdButtonLabel, this.onClickRewardedAdsButton, this);
        this.rewardedAdsButton.x = this.hintButton.x + 65;
        this.rewardedAdsButton.y = this.hintButton.y - 15;
        this.rewardedAdsButton.visible = false;
        this.add(this.rewardedAdsButton);

        this.scene.tweens.add({
            targets: this.rewardedAdsButton,
            scaleX: 1.125,
            scaleY: 1.125,
            duration: 500,
            ease: Phaser.Math.Easing.Linear,
            yoyo: true,
            repeat: -1
        });
    }

    public startGame(): void {  
    
        this.hintsCounterLabel.text = GameVars.mahjongEngine.boardData.hints.toString();

        if (GameVars.mahjongEngine.boardData.hints === 0) {

            this.hintsLabelBackground.visible = false;
            this.hintsCounterLabel.visible = false;
            
            this.hintButton.disable();
        }
    }

    public onMatch(): void {

        if (GameConstants.REWARDED_ADS && GameVars.mahjongEngine.boardData.hints === 0) {

            this.scene.time.delayedCall(750, () => {
                this.rewardedAdsButton.visible = true;
            }, [], this);
        }
    }

    public onHint(): void {

        this.hintsCounterLabel.text = GameVars.mahjongEngine.boardData.hints.toString();

        if (GameVars.mahjongEngine.boardData.hints === 0) {

            this.hintsLabelBackground.visible = false;
            this.hintsCounterLabel.visible = false;
             
            this.hintButton.disable(); 
        }
    }

    private onClickRewardedAdsButton(): void {
        
        this.rewardedAdsButton.visible = false;

        const self = this;

        const callbacks = {
            adFinished: () => {
                if (!GameVars.gameData.muted) {
                    AudioManager.unmute();
                }

                GameVars.mahjongEngine.boardData.hints = 3;

                self.hintButton.enable();
                self.hintsCounterLabel.text = GameVars.mahjongEngine.boardData.hints.toString();
                self.hintsLabelBackground.visible = true;
                self.hintsCounterLabel.visible = true; 
            },
            adError: (error, errorData) =>  {
                // nada
            },
            adStarted: () => {
                if (!GameVars.gameData.muted) {
                    AudioManager.mute();
                }
            }
        };

        const w = <any> window;
        w.CrazyGames.SDK.ad.requestAd("rewarded", callbacks);
    }

    private onClickHint(): void {

        if (GameVars.paused || BoardContainer.currentInstance.isBoardShowingHint()) {
            return;
        }
       
        GameVars.mahjongEngine.hint();
    }
}
